<section>
  <div class="f-col">
    <h2>Explore more</h2>
    <div class="f-row btn-container">
      
          <a *ngFor="let l of links;" class="btn btn--white" [routerLink]="l.link" routerLinkActive="active" [attr.data-cta]="l.titlecta" [attr.title]="l.title">{{ l.title }}</a>
      
    </div>
  </div>
</section>